import { PostRequest } from "./http/BaseRequest";
/*
export const sendConfirm = (email: string): Promise<AxiosResponse<ServerResponse> | Error> => {
  return service.api.post("/user/confirm_email", {
    email,
  });
};
*/
export class ConfirmEmailRequest extends PostRequest {
  constructor(email: string) {
    super("/user/confirm_email", {
      email
    });
  }
}
/*
export const deleteEmail = (email: string): Promise<AxiosResponse<ServerResponse> | Error> => {
  return service.api.post("/user/remove_email", {
    email,
  });
};*/

export class DeleteEmailRequest extends PostRequest {
  constructor(email : string) {
    super("/user/remove_email", { email });
  }
}
/*
export const verifyEmail = (
  email: string,
  code: string
): Promise<AxiosResponse<ServerResponse> | Error> => {
  return service.api.post("/user/verify_email", {
    email,
    code,
  });
};
*/

export class VerifyEmailRequest extends PostRequest {
  constructor(
    email: string,
    code: string
  ) {
    super("/user/verify_email", {
      email,
      code,
    });
  }
}